import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber1Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNumber1Square"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M11.9785 16.2275V8.94434H11.8848L9.73438 10.5029V9.38965L11.9844 7.77246H13.0332V16.2275H11.9785Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber1Square;
